import * as apiClient from '../api/apiClient';
import { buildPagedQuery } from '../api/pagedQuery';
import { unwrapPagedResponseModel, unwrapResponseModel } from '../api/responseModel';

async function requestAndUnwrap(requestPromise) {
  const { data } = await requestPromise;
  return unwrapResponseModel(data);
}

function createPagedList(indexPath) {
  return (query = { page: 1, pageSize: 10 }) => {
    const qs = buildPagedQuery(query);
    return apiClient.get(`${indexPath}?${qs}`).then(({ data }) => unwrapPagedResponseModel(data));
  };
}

function createCorrelatividadCursarResource() {
  const listPaged = createPagedList('/api/ccursar/Index');
  return {
    resetForTests() {
      // Sin caché deduplicada tras F4-011.
    },
    list(query) {
      return listPaged(query);
    },
    lookup(query) {
      return listPaged({ pageSize: 5, ...query });
    },
    get(id) {
      return requestAndUnwrap(apiClient.get(`/api/ccursar/${id}`));
    },
    delete(id) {
      return requestAndUnwrap(apiClient.get(`/api/ccursar/delete/${id}`));
    },
    save(payload) {
      return requestAndUnwrap(apiClient.post('/api/ccursar', payload));
    }
  };
}

function createCorrelatividadRendirResource() {
  const listPaged = createPagedList('/api/crendir/Index');
  return {
    resetForTests() {
      // Sin caché deduplicada tras F4-011.
    },
    list(query) {
      return listPaged(query);
    },
    lookup(query) {
      return listPaged({ pageSize: 5, ...query });
    },
    get(id) {
      return requestAndUnwrap(apiClient.get(`/api/crendir/${id}`));
    },
    delete(id) {
      return requestAndUnwrap(apiClient.get(`/api/crendir/delete/${id}`));
    },
    save(payload) {
      return requestAndUnwrap(apiClient.post('/api/crendir', payload));
    }
  };
}

const correlatividadCursar = createCorrelatividadCursarResource();
const correlatividadRendir = createCorrelatividadRendirResource();

export function resetCorrelatividadesCursarListCacheForTests() {
  correlatividadCursar.resetForTests();
}

export function resetCorrelatividadesRendirListCacheForTests() {
  correlatividadRendir.resetForTests();
}

export function listCorrelatividadesCursar(query) {
  return correlatividadCursar.list(query);
}

export function lookupCorrelatividadesCursar(query) {
  return correlatividadCursar.lookup(query);
}

export function getCorrelatividadCursar(id) {
  return correlatividadCursar.get(id);
}

export function deleteCorrelatividadCursar(id) {
  return correlatividadCursar.delete(id);
}

export function saveCorrelatividadCursar(payload) {
  return correlatividadCursar.save(payload);
}

export function listCorrelatividadesRendir(query) {
  return correlatividadRendir.list(query);
}

export function lookupCorrelatividadesRendir(query) {
  return correlatividadRendir.lookup(query);
}

export function getCorrelatividadRendir(id) {
  return correlatividadRendir.get(id);
}

export function deleteCorrelatividadRendir(id) {
  return correlatividadRendir.delete(id);
}

export function saveCorrelatividadRendir(payload) {
  return correlatividadRendir.save(payload);
}
